__turbopack_context__.v({
  "faq-block": "DlTMKq_faq-block",
  "faq-block--dawn": "DlTMKq_faq-block--dawn",
  "faq-block--dawn-2": "DlTMKq_faq-block--dawn-2",
  "faq-block--dusk": "DlTMKq_faq-block--dusk",
  "faq-block--light-dusk": "DlTMKq_faq-block--light-dusk",
  "faq-block--midnight": "DlTMKq_faq-block--midnight",
  "faq-block--midnight-2": "DlTMKq_faq-block--midnight-2",
  "faq-block--warm-red": "DlTMKq_faq-block--warm-red",
  "faq-block__body": "DlTMKq_faq-block__body",
  "faq-block__content": "DlTMKq_faq-block__content",
  "faq-block__filter": "DlTMKq_faq-block__filter",
  "faq-block__flourish": "DlTMKq_faq-block__flourish",
  "faq-block__header": "DlTMKq_faq-block__header",
  "faq-block__heading": "DlTMKq_faq-block__heading",
  "faq-block__inner": "DlTMKq_faq-block__inner",
  "faq-block__list": "DlTMKq_faq-block__list",
  "faq-block__radio-input": "DlTMKq_faq-block__radio-input",
  "faq-block__radio-label": "DlTMKq_faq-block__radio-label",
  "faq-block__wrapper": "DlTMKq_faq-block__wrapper",
});
